// 極簡全域 toast — mutation 回饋 (UX 稽核 #2: 全站原本沒有任何成功回饋機制,
// 使用者無法知道「存進去了沒」)。 Zustand store + Layout 掛一個 <Toaster/>,
// 任何地方 `toast('已儲存')` 即右下角浮 2.5 秒。
//
// 2026-07-31: 原本這裡只設計給成功訊息 (渲染硬寫死 ✓ 綠勾), 但實際上有 7 處
// mutation 的 onError 也在呼叫它 → **錯誤訊息被掛上綠色打勾**, 例如
// 「✓ [400] 「執行」關必須排在所有「審核」關之後」。 圖示說成功、文字說失敗,
// 掃過去只看得到 ✓ 就以為存好了。 故加 variant, 錯誤停留久一點 (5 秒)。
import { create } from 'zustand';

export type ToastVariant = 'success' | 'error';

export interface ToastItem {
  id: number;
  message: string;
  variant: ToastVariant;
}

interface ToastState {
  items: ToastItem[];
  push: (message: string, variant?: ToastVariant) => void;
  remove: (id: number) => void;
}

let nextId = 1;

export const useToasts = create<ToastState>()((set) => ({
  items: [],
  push: (message, variant = 'success') => {
    const id = nextId++;
    set((s) => ({ items: [...s.items, { id, message, variant }] }));
    // 自動消失。 錯誤訊息通常比較長且需要讀懂 → 給久一點。
    setTimeout(
      () => {
        set((s) => ({ items: s.items.filter((t) => t.id !== id) }));
      },
      variant === 'error' ? 5000 : 2500,
    );
  },
  remove: (id) => set((s) => ({ items: s.items.filter((t) => t.id !== id) })),
}));

/** 顯示一則成功/中性 toast (右下角, 2.5 秒自動消失)。 */
export function toast(message: string): void {
  useToasts.getState().push(message, 'success');
}

/** 顯示一則錯誤 toast (紅底 ⚠, 5 秒)。 mutation 的 onError 用這支, 不要用 toast()。 */
export function toastError(message: string): void {
  useToasts.getState().push(message, 'error');
}
